import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { MovieModel } from '../../core/interfaces/movie.model';

@Component({
  selector: 'app-ui-slides-carousel',
  templateUrl: './ui-slides-carousel.component.html',
  styleUrls: ['./ui-slides-carousel.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UiSlidesCarouselComponent implements OnInit {
  @Input() movies: MovieModel[] = [];
  @Input() title: string;
  @Input() swiperConfig: SwiperConfigInterface;
  @Input() noBorders: boolean = false;
  @Input() showInfo: boolean = false;
  @Input() felixoliver: boolean = false;

  swiperIndex = 0;


  constructor() {
    this.swiperConfig = {
      slidesPerView: 2,
      spaceBetween: -10,
      navigation: true,
      breakpoints: {
        480: { slidesPerView: 3 },
        700: { slidesPerView: 4 },
        1000: { slidesPerView: 6 },
        1600: { slidesPerView: 8 }
      }
    }
  }

  ngOnInit(): void {
  }

}
